import * as yup from "yup";
import { addKeyToFieldsRecursively } from "@/react/schema/schemaFields";
import {
  PBX_CLASS_TYPES,
  PBX_DIAL_PLAN_RULE_SETS,
  PBX_REGIONS,
  PBX_STATUSES,
  PBX_TYPES,
} from "./constants";
import { checkNameCollision } from "@/react/features/smp/pbx/nameCheckValidation";

const schema = yup.object({
  pbxId: yup.string().nullable(),
  name: yup
    .string()
    .required()
    .test("name", "Name validation error", checkNameCollision),
  region: yup.string().nullable().oneOf(Object.values(PBX_REGIONS)),
  status: yup.string().nullable().oneOf(Object.values(PBX_STATUSES)),
  locale: yup.string().nullable(),
  timezoneId: yup.string().nullable(),
  dialPlanName: yup.string().nullable(),
  dialPlanRuleSetName: yup
    .string()
    .nullable()
    .oneOf(Object.values(PBX_DIAL_PLAN_RULE_SETS)),
  details: yup.object({
    type: yup.string().nullable().oneOf(Object.values(PBX_TYPES)),
    classType: yup.string().nullable().oneOf(Object.values(PBX_CLASS_TYPES)),
    maxSwitchBoardConnections: yup.string().nullable(),
    emergencyAddressId: yup.string().nullable(),
    emergencyAddress: yup.object({
      freeForm: yup.string().nullable(),
    }),
    extensionLength: yup.string().nullable(),
  }),
});

addKeyToFieldsRecursively(schema);

export default schema;
